import { TipoNotificacaoEnum } from "../../enums/tipo-notificacao-enum";

export class NotificacaoSmsPK {

    numLote: number = 0;

    tipoNotificacao: TipoNotificacaoEnum = TipoNotificacaoEnum.CAN;

    dataNotificacao: Date = new Date();

    numTelefone: string = '';

    constructor() {
    }
}
